/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Author_EngineInputs */

const en_us2_draft_author_engine = /** @type {(inputs: Draft_Author_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested by the app`)
};

const pt_br2_draft_author_engine = /** @type {(inputs: Draft_Author_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestão do app`)
};

const es_419_draft_author_engine = /** @type {(inputs: Draft_Author_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerencia de la app`)
};

const pt_pt2_draft_author_engine = /** @type {(inputs: Draft_Author_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestão da app`)
};

const fr_fr2_draft_author_engine = /** @type {(inputs: Draft_Author_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggéré par l'app`)
};

const de_de2_draft_author_engine = /** @type {(inputs: Draft_Author_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlag der App`)
};

const it_it2_draft_author_engine = /** @type {(inputs: Draft_Author_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerita dall'app`)
};

/**
* | output |
* | --- |
* | "Suggested by the app" |
*
* @param {Draft_Author_EngineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_author_engine = /** @type {((inputs?: Draft_Author_EngineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Author_EngineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_author_engine(inputs)
	if (locale === "es-419") return es_419_draft_author_engine(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_author_engine(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_author_engine(inputs)
	if (locale === "de-DE") return de_de2_draft_author_engine(inputs)
	if (locale === "it-IT") return it_it2_draft_author_engine(inputs)
	return en_us2_draft_author_engine(inputs)
});
export { draft_author_engine as "draft.author_engine" }